import React from 'react';
import { LayoutGroup, motion } from 'motion/react';
import { SPRING_PILL } from '../../motion/tokens';
import usePrefersReducedMotion from '../../motion/usePrefersReducedMotion';

export default function UnderlineTabs({
  value,
  onChange,
  options,
  layoutId = 'underline-tabs',
  className = '',
}) {
  const reduced = usePrefersReducedMotion();

  return (
    <LayoutGroup id={layoutId}>
      <nav
        className={`flex gap-1 overflow-x-auto border-b border-gray-200 px-2 sm:gap-2 sm:px-4 ${className}`.trim()}
        role="tablist"
        aria-label="Sections"
      >
        {options.map((option) => {
          const active = value === option.id;
          return (
            <button
              key={option.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange(option.id)}
              className={`relative shrink-0 px-3 py-3.5 text-sm font-medium transition-colors duration-150 active:scale-[0.98] sm:px-4 ${
                active ? 'text-teal-700' : 'text-gray-500 hover:text-gray-800'
              }`}
            >
              {option.label}
              {active && !reduced && (
                <motion.span
                  layoutId={`${layoutId}-indicator`}
                  className="absolute inset-x-2 -bottom-px h-0.5 rounded-full bg-teal-600"
                  transition={SPRING_PILL}
                />
              )}
              {active && reduced && (
                <span className="absolute inset-x-2 -bottom-px h-0.5 rounded-full bg-teal-600" />
              )}
            </button>
          );
        })}
      </nav>
    </LayoutGroup>
  );
}
